module.exports = __webpack_public_path__ + "static/media/20ECE15.ec7ede52.jpg";